// Lulobee — The Lucky Girl Journal — scripts propios
(function () {
  "use strict";

  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal, .mt-reveal-stagger");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initVistazoCarrusel() {
    document.querySelectorAll("[data-mt-carrusel]").forEach(function (wrap) {
      var track = wrap.querySelector("[data-mt-track]");
      var prev = wrap.querySelector("[data-mt-prev]");
      var next = wrap.querySelector("[data-mt-next]");
      if (!track) return;
      function scrollByCard(dir) {
        var card = track.querySelector("[data-mt-card]");
        var gap = 24;
        var amount = card ? card.offsetWidth + gap : 320;
        track.scrollBy({ left: dir * amount, behavior: "smooth" });
      }
      if (prev) prev.addEventListener("click", function () { scrollByCard(-1); });
      if (next) next.addEventListener("click", function () { scrollByCard(1); });
    });
  }

  function initProductoGaleria() {
    document.querySelectorAll("[data-mt-producto]").forEach(function (root) {
      var main = root.querySelector("[data-mt-main-img]");
      var thumbs = root.querySelectorAll("[data-mt-thumb]");
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var url = thumb.getAttribute("data-full");
          if (url) main.setAttribute("src", url);
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  function initProductoVariantes() {
    document.querySelectorAll("[data-mt-producto]").forEach(function (root) {
      var select = root.querySelector("[data-mt-variant-select]");
      var idInput = root.querySelector("[data-mt-variant-id]");
      var priceEl = root.querySelector("[data-mt-precio]");
      var compareEl = root.querySelector("[data-mt-precio-comparado]");
      var addBtn = root.querySelector("[data-mt-add]");
      var dataEl = root.querySelector("[data-mt-variants-json]");
      if (!select || !dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      select.addEventListener("change", function () {
        var variant = variants.filter(function (v) { return String(v.id) === select.value; })[0];
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = "";
          } else {
            compareEl.style.display = "none";
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available
            ? addBtn.getAttribute("data-text-disponible")
            : addBtn.getAttribute("data-text-agotado");
        }
      });
    });
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    return value + " €";
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initVistazoCarrusel();
    initProductoGaleria();
    initProductoVariantes();
  });
})();
